import React from 'react';

import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { doesTooltipNotHaveOwnerToDisplay } from '~src/spacesPlatform/components/tooltip/Tooltip';
import { TooltipAnchor } from '~src/spacesPlatform/components/tooltip/TooltipAnchor';

import { Messages } from '../../../codegen/Localize';
import { PredictiveModelTooltip } from '../tooltips/PredictiveModelTooltip';
import { PredictiveModelThumbnail } from './PredictiveModelThumbnail';

export class PredictiveModelCard extends ContentCard {
  public render() {
    const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(this.props.content);

    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor
          tooltipContent={this.renderTooltipContent}
          width={DetailsTooltipStyles.Width}
          onShowTooltip={this.handleShowTooltip}
          delay={0}
          title={Messages.predictiveModelTooltipTitle()}
          disableAutoFocus={disableAutoFocus}
          disableTooltip={this.props.disableTooltip}
        >
          <PredictiveModelThumbnail
            hoveredOrSelected={this.props.hoveredOrSelected}
            navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
            owner={this.props.content.owner}
            urls={this.props.urls}
            aria-label={this.props.content.name}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName}>
            {this.props.content.name}
          </span>
          <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'predictiveModel'})}
              onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'predictiveModel'})} />
          </span>
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }
  private renderTooltipContent = () => {
    return <PredictiveModelTooltip
      content={this.props.content}
      urls={this.props.urls} />;
  };
}
